import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import * as React from 'react';

import { logError } from '@/imports/logging/ClientLogger';
import { CameraIcon, TrashIcon, UploadIcon } from '@/imports/ui/chakra/feather';
import { ImageUploadModal } from '@/imports/ui/components/ImageUploadModal';

type BannerImageMenuProps = {
  hasBannerImage?: boolean;
  allowRemove: boolean;
  updateBannerImage: (bannerImageId: any) => Promise<any>;
  isLoading?: boolean;
};

export const BannerImageMenu: React.FC<BannerImageMenuProps> = (props) => {
  const modal = useDisclosure();
  const toast = useToast();

  return (
    <Box
      borderRadius="base"
      boxShadow="base"
      position="absolute"
      bottom={4}
      right={4}
    >
      {props.hasBannerImage && props.allowRemove ? (
        <Menu>
          <MenuButton
            as={Button}
            aria-label="Add Cover Photo"
            leftIcon={<CameraIcon />}
            colorScheme="gray"
            bg="white"
          >
            Edit Cover Photo
          </MenuButton>
          <MenuList>
            <MenuItem icon={<UploadIcon />} onClick={modal.onOpen}>
              Upload New Cover Photo
            </MenuItem>
            <MenuItem
              icon={<TrashIcon />}
              onClick={async () => {
                try {
                  await props.updateBannerImage(null);
                  toast({
                    title: 'Successfully removed cover photo',
                  });
                } catch (error) {
                  logError(error);
                  toast({
                    title: 'Failed to remove cover photo',
                    status: 'error',
                  });
                }
              }}
            >
              Remove
            </MenuItem>
          </MenuList>
        </Menu>
      ) : (
        <Button
          leftIcon={<CameraIcon />}
          colorScheme="gray"
          bg="white"
          onClick={modal.onOpen}
        >
          {props.hasBannerImage ? 'Edit Cover Photo' : 'Add Cover Photo'}
        </Button>
      )}
      <ImageUploadModal
        isOpen={modal.isOpen}
        onClose={modal.onClose}
        title="Upload a Cover Photo"
        subtitle="The image size is 1600px by 600px"
        height={600}
        width={1600}
        onSubmit={async (files) => {
          try {
            await props.updateBannerImage(files[0]);
            modal.onClose();
            toast({
              title: 'Successfully added cover photo',
            });
          } catch (error) {
            logError(error);
            toast({
              title: 'Failed to add cover photo',
              status: 'error',
            });
          }
        }}
        isLoading={props.isLoading}
        objectFit={'contain'}
      />
    </Box>
  );
};
